import { useGlobalQuery } from '@/state/query-client/hooks';
import { getLeaveCalendarData } from '../services/leave-calendar.service';
import { GetLeaveCalendarParams } from '../types/leave-calendar.types';

export const useGetLeaveCalendarData = (params: GetLeaveCalendarParams) => {
  return useGlobalQuery({
    queryKey: ['hr-leave-calendar', params],
    queryFn: () => getLeaveCalendarData(params),
    staleTime: 60 * 1000,
  });
};
